import { getTenantDictionary } from '@/services/tenant';
import { formatJson } from '@/utils/utils';
import { useState } from 'react';

/**
 * 租户字典（下拉数据源）
 *
 * 数据源：GET /tenant/dictionary，接口只返回「启用中」的租户，形状为 { id, name }[]。
 * 这里统一格式化成 antd Select 需要的 { value, label } 结构（与 userModel 的 roleList 口径一致），
 * 供账号管理（用户租户字段）复用。
 *
 * 拉取时机：由消费方在「进入页面 / 打开弹窗」时调用 fetchTenantList()。
 * 模型本身不挂载拉取、也不监听事件 —— 与 saasTicketModel、userModel 的
 * 「model 持有数据 + 暴露拉取方法，由页面决定何时拉」保持一致。
 */
export default () => {
  // 下拉选项，形状 { value: 租户id, label: 租户名称 }
  const [tenantList, setTenantList] = useState<any[]>([]);

  // 拉取租户字典并格式化为 { value, label }
  const fetchTenantList = async () => {
    const tenant = await getTenantDictionary();
    setTenantList(formatJson(tenant || [], { id: 'value', name: 'label' }));
    return tenant || [];
  };

  return {
    tenantList,
    fetchTenantList,
  };
};
